import { useState } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { call, type Schema } from './api';
import { estimateHref, estimatePreparation, spartakSource, spartakEstimate, spartakEstimateRevision } from './spartakEstimate';
export { estimatePreparation, spartakSource, spartakEstimate, spartakEstimateRevision } from './spartakEstimate';

export function SpartakEstimatePreparation({ projectId, canEdit }: { projectId: string; canEdit: boolean }) {
  if (projectId === spartakSource) return <section className="notice estimate-preparation">
    <div><strong>Смета всех объектов</strong><p>Отдельная сметная копия с базой и ценами 2026 года по образцу КПП. Запуск выполняет Роман; принятая ВОР сохраняется.</p>
      <a className="button-link" href={estimateHref}>Открыть смету всех объектов</a></div>
  </section>;
  if (projectId !== spartakEstimate) return null;
  return <PreparedEstimate canEdit={canEdit} />;
}

function PreparedEstimate({ canEdit }: { canEdit: boolean }) {
  const cache = useQueryClient();
  const [busy, setBusy] = useState(false), [error, setError] = useState('');
  const jobs = useQuery({ queryKey: ['jobs', spartakEstimateRevision],
    queryFn: () => call<Schema['JobOut'][]>(`/api/v1/revisions/${spartakEstimateRevision}/jobs`), refetchInterval: 5000 });
  const job = jobs.data?.find(j => estimatePreparation(j));
  const state = job ? estimatePreparation(job) : null;
  const active = !!job && ['queued', 'running', 'waiting'].includes(job.status);
  async function start() {
    setBusy(true); setError('');
    try {
      await call<Schema['JobOut']>(`/api/v1/revisions/${spartakEstimateRevision}/analyze`, { method: 'POST', body: { provider: 'codex', mode: 'norms' } });
      await cache.invalidateQueries({ queryKey: ['jobs', spartakEstimateRevision] });
      await cache.invalidateQueries({ queryKey: ['full-estimate', spartakEstimateRevision] });
    } catch (cause) { setError(String(cause)); await jobs.refetch(); }
    finally { setBusy(false); }
  }
  return <section className="notice estimate-preparation" aria-label="Подготовка сметы всех объектов">
    <div><strong>{state?.ready ? 'Предварительная смета сохранена' : 'Подготовка сметы всех объектов'}</strong>
      <p>Все пять частей, 478 работ. ФСНБ-2022 №435/пр · Московская область, II квартал 2026 · ресурсно-индексный метод.</p>
      <p>Один запуск: подбор норм и материалов → расчёт → Word, Excel, PDF и общий ZIP. Объёмы и ручные решения ВОР сохраняются.</p>
      {job && <p role="status">{job.message}{state && <> · Сохранено групп: {state.count}{state.total !== null && ` из ${state.total}`}</>}</p>}
      {state?.href ? <a className="primary button-link" href={state.href} download>Скачать смету и принятую ВОР — все объекты (ZIP)</a>
        : canEdit && <button className="primary" disabled={busy || active || jobs.isPending || jobs.isError} onClick={() => void start()}>
          {busy ? 'Отправляем запуск…' : active ? 'Подготовка идёт на сервере…' : job ? 'Продолжить подготовку сметы' : 'Подготовить смету всех объектов'}
        </button>}
      <p className="muted">Неизвестные объёмы и цены будут перечислены отдельно. Смета предварительная; профессиональное подтверждение выполняет Роман.</p>
      {(error || jobs.error) && <p role="alert" className="error">{error || String(jobs.error)}</p>}
    </div>
  </section>;
}
